import * as fmt from '../../lib/format';
// How a change against the month before reads, for the Tech view's figures. Months are "YYYY-MM"; nothing here reads
// the browser's timezone.

// ─── Change against the month before ─────────────────────────────

export type Direction = 'up' | 'down' | 'flat' | 'none';
export type Tone = 'good' | 'nudge' | 'steady' | 'none';
export interface Change {
  direction: Direction;
  text: string;
  tone: Tone;
}

/** Up is green, down is amber (a nudge to look, not a failure), no change is grey. */
export function describeChange(changePct: number | null): Change {
  if (changePct === null) return { direction: 'none', text: 'no comparison yet', tone: 'none' };
  if (changePct === 0) return { direction: 'flat', text: 'no change', tone: 'steady' };
  return changePct > 0
    ? { direction: 'up', text: fmt.percent(changePct), tone: 'good' }
    : { direction: 'down', text: fmt.percent(Math.abs(changePct)), tone: 'nudge' };
}

/** What the change is against: the same first days of the month before while the month is open. */
export function comparedWith(o: { previous_period: string; days_compared: number; period_over: boolean }): string {
  if (o.days_compared === 0) return '';
  const name = fmt.monthOnly(o.previous_period);
  if (o.period_over) return `vs ${name}`;
  return `vs the first ${o.days_compared} ${o.days_compared === 1 ? 'day' : 'days'} of ${name}`;
}
